export default __webpack_public_path__ + "static/velocidad-e21d7e788fc557487a9d462750edb1c8.png";